import React, { Component } from "react";
import expandCollapse from "../../assets/expand_more_black_24dp.svg";
import close from "../../assets/cancel_black_24dp.svg";
import download from "../../assets/file_download_black_24dp.svg";
import download_ready from "../../assets/download_ready.svg";
import cancel from "../../assets/Shape.svg";
import white_close from "../../assets/white-close.svg";
import tick from "../../assets/tick.svg";
import "./DownloadReportStyle.scss";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { Dialog } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const styles = {
  dialogPaper: {
    width: "650px",
    padding: "50px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
  },
};

class DownloadReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      openDownload: false,
      downloadReport: [],
      cancelInd: null,
      openCancelPopup: false,
      cancelAll: false,
      header: "Preparing download",
      progressFailedPopup: false,
      popUpTitle: "",
      popUpContent: "",
    };
  }

  componentDidMount() {
    C2CConsole.log("Download Report");
    if (
      localStorage.getItem("DownloadReport") &&
      localStorage.getItem("DownloadReport") === "true"
    ) {
      this.setState({ openDownload: true });
    } else {
      this.setState({ openDownload: false });
    }

    let arr = [];
    arr = localStorage.getItem("DownloadReportArr")
      ? JSON.parse(localStorage.getItem("DownloadReportArr"))
      : [];
    this.setState({
      downloadReport: arr,
      openDownload: arr.length !== 0 ? true : false,
    });
    this.setDownloadReady(arr);
    this.enableDownload(arr);
    this.callHandleProgress(arr);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.downloadReport !== this.props.downloadReport) {
      this.setState({ downloadReport: this.props.downloadReport });
      this.setDownloadReady(this.props.downloadReport);
      this.enableDownload(this.props.downloadReport);
      this.callHandleProgress(this.props.downloadReport);
    }
  }

  enableDownload = (downloadReport) => {
    let appnt = [],
      trans = [],
      patient = [],
      dayCollection = [],
      followUp = [],
      newLead = [];

    downloadReport.forEach((dwn) => {
      if (dwn.requestType === "appointment") {
        appnt.push(dwn.progress === 100 || dwn.progressFailed);
      }
      if (dwn.requestType === "transactions" || dwn.requestType === "summary") {
        trans.push(dwn.progress === 100 || dwn.progressFailed);
      }
      if (dwn.requestType === "patient") {
        patient.push(dwn.progress === 100 || dwn.progressFailed);
      }
      if (dwn.requestType === "daybook_collection") {
        dayCollection.push(dwn.progress === 100 || dwn.progressFailed);
      }
      if (dwn.requestType === "follow_up") {
        followUp.push(dwn.progress === 100 || dwn.progressFailed);
      }
      if (dwn.requestType === "new_lead") {
        newLead.push(dwn.progress === 100 || dwn.progressFailed);
      }
    });
    let appntAll = appnt.every((ap) => ap);
    let transAll = trans.every((ap) => ap);
    let patientAll = patient.every((ap) => ap);
    let dayCollectionAll = dayCollection.every((ap) => ap);
    let followUpAll = followUp.every((fu) => fu);
    let newLeadAll = newLead.every((nl) => nl);
    if (appntAll) {
      localStorage.setItem("AppntDisableDownload", "false");
      if (typeof this.props.handleAppntDisableDownload === "function") {
        this.props.handleAppntDisableDownload();
      }
    }
    if (transAll) {
      localStorage.setItem("TransDisableDownload", "false");
      if (typeof this.props.handleTransDisableDownload === "function") {
        this.props.handleTransDisableDownload();
      }
    }
    if (patientAll) {
      localStorage.setItem("PatientDisableDownload", "false");
      if (typeof this.props.handlePatientDisableDownload === "function") {
        this.props.handlePatientDisableDownload();
      }
    }
    if (dayCollectionAll) {
      localStorage.setItem("DayCollectionDisableDownload", "false");
      if (typeof this.props.handleDisableDayCollectionDownload === "function") {
        this.props.handleDisableDayCollectionDownload();
      }
    }
    if (followUpAll) {
      localStorage.setItem("FollowUpDisableDownload", "false");
      if (typeof this.props.handleDisableFollowUpDownload === "function") {
        this.props.handleDisableFollowUpDownload();
      }
    }
    if (newLeadAll) {
      localStorage.setItem("NewLeadDisableDownload", "false");
      if (typeof this.props.handleDisableNewLeadDownload === "function") {
        this.props.handleDisableNewLeadDownload();
      }
    }
  };

  handleProgress = (downloadReport) => {
    downloadReport.forEach((dwnld) => {
      if (dwnld.progress !== 100) {
        setInterval(
          () => {
            if (
              dwnld.progress !== 100 &&
              !dwnld.pause &&
              !dwnld.progressFailed
            ) {
              this.getProgress(dwnld, downloadReport);
            } else {
              if (dwnld.progress === 100 && !dwnld.signedLink) {
                this.enableDownload(downloadReport);
                this.setDownloadReady(downloadReport);
                this.getSignedLink(dwnld, downloadReport);
              }
            }
          },
          dwnld.progress === 0 || !dwnld.progress ? 1000 : 500
        );
      } else {
        if (dwnld.progress === 100 && !dwnld.signedLink) {
          this.getSignedLink(dwnld, downloadReport);
        }
      }
    });
  };

  getProgress = (dwnld, downloadReport) => {
    afterLoginApiAxios
      .post(
        `/download-report/progress`,
        {
          report_type: dwnld.requestType,
          request_id: dwnld.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data) {
          let ind = downloadReport.findIndex(
            (dwn) => dwn.id === res.data.request_id
          );
          if (ind !== -1) {
            downloadReport[ind].progress = downloadReport[ind].pause
              ? downloadReport[ind].progress_per
              : res.data.progress_per;
            if (res.data.status === "failed") {
              downloadReport[ind].progressFailed = true;
              this.setState({
                popUpTitle: "Download Request Failed",
                popUpContent:
                  "Your download request has failed. Please click on download again.",
              });
              this.progressFailedPopup();
              this.enableDownload(downloadReport);
              this.setDownloadReady(downloadReport);
            } else if (res.data.status === "no_data") {
              downloadReport[ind].progressFailed = true;
              this.setState({
                popUpTitle: "No Records Found",
                popUpContent:
                  "There are no records available for selected period, so file can not be downloaded.",
              });
              this.progressFailedPopup();
              this.enableDownload(downloadReport);
              this.setDownloadReady(downloadReport);
            }
          }
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          let reqInd = arr.findIndex((ar) => ar.id === res.data.request_id);
          if (reqInd !== -1) {
            localStorage.setItem(
              "DownloadReportArr",
              JSON.stringify(downloadReport)
            );
          }
          this.setState({ downloadReport });
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  getSignedLink = (dwnld, downloadReport) => {
    afterLoginApiAxios
      .post(
        `/download-report/link`,
        {
          report_type: dwnld.requestType,
          request_id: dwnld.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data) {
          let ind = downloadReport.findIndex(
            (dwn) => dwn.id === res.data.request_id
          );
          if (ind !== -1) {
            downloadReport[ind].signedLink = res.data.s3_signed_link;
          }
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          let reqInd = arr.findIndex((ar) => ar.id === res.data.request_id);
          if (reqInd !== -1) {
            localStorage.setItem(
              "DownloadReportArr",
              JSON.stringify(downloadReport)
            );
          }
          this.setState({ downloadReport });
          this.setDownloadReady(downloadReport);
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  progressFailedPopup = () => {
    this.setState({ progressFailedPopup: true });
  };

  closePopup = () => {
    this.setState({ progressFailedPopup: false });
  };

  setDownloadReady = (downloadReport) => {
    let progressAll = [];
    downloadReport.forEach((dwn) => {
      progressAll.push(dwn.progress === 100 || dwn.progressFailed);
    });
    let downloadAll = progressAll.every((pro) => pro);
    let failedAll = downloadReport.every((dwn) => dwn.progressFailed);
    if (failedAll) {
      this.setState({ header: "Download failed" });
    } else {
      if (downloadAll) {
        this.setState({ header: "Download ready" });
      } else {
        this.setState({ header: "Preparing download" });
      }
    }
  };

  showDownloadReport = () => {
    this.setState({ openDownload: true });
  };

  toggleExpandCollapse = () => {
    let open = !this.state.open;
    this.setState({ open });
  };

  cancelDownload = (ind) => {
    let downloadReport = this.state.downloadReport;
    downloadReport[ind].pause = true;
    this.callHandleProgress(downloadReport);
    this.setState({
      downloadReport,
      cancelInd: ind,
      openCancelPopup: true,
      cancelAll: false,
    });
  };

  displayDownloadBody = () => {
    const { open } = this.state;
    const { downloadReport } = this.state;
    let display = null;
    if (open) {
      display = downloadReport.map((file, indD) => (
        <div className="Download-body" key={indD}>
          <div
            style={{
              display: "flex",
              flex: "1",
              alignItems: "center",
              width: "80%",
            }}
          >
            <div
              style={{
                marginRight: "10px",
                cursor:
                  file.progress !== 100 && !file.progressFailed
                    ? "pointer"
                    : "",
                width: "20px",
                height: "20px",
              }}
              onClick={() =>
                file.progress !== 100 && !file.progressFailed
                  ? this.cancelDownload(indD)
                  : ""
              }
            >
              <CircularProgressbarWithChildren
                value={file.progress ? file.progress : 0}
                background
                backgroundPadding={0}
                styles={buildStyles({
                  pathColor: "#F969A4",
                  trailColor: file.progressFailed
                    ? "red"
                    : file.progress !== 100
                    ? "#edf0ef"
                    : "#F969A4",
                  color: "#F969A4",
                  pathTransitionDuration: 0.5,
                  backgroundColor: file.progressFailed
                    ? "red"
                    : file.progress !== 100
                    ? "#fff"
                    : "#F969A4",
                })}
              >
                <img
                  src={
                    file.progressFailed
                      ? white_close
                      : file.progress === 100
                      ? tick
                      : cancel
                  }
                  alt=""
                  style={{
                    marginBottom: "5.5px",
                    width: file.progress === 100 ? "8.5px" : "8px",
                  }}
                />
              </CircularProgressbarWithChildren>
            </div>
            <div className="Download-body-title">{file.filename}</div>
          </div>
          <div
            style={{
              cursor: file.signedLink ? "pointer" : "not-allowed",
              paddingTop: "1.5px",
              width: "20px",
              height: "20px",
            }}
            onClick={() => (file.signedLink ? this.downloadFile(indD) : "")}
          >
            <img src={file.signedLink ? download_ready : download} alt="" />
          </div>
        </div>
      ));
    }
    return display;
  };

  downloadFile = (ind) => {
    let downloadReport = this.state.downloadReport;
    let link = document.createElement("a");
    link.href = downloadReport[ind].signedLink;
    link.download = downloadReport[ind].filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  callHandleProgress = (downloadReport) => {
    this.handleProgress(downloadReport);
  };

  closeDownload = () => {
    let downloadReport = this.state.downloadReport;
    downloadReport.forEach((dwn) => {
      dwn.pause = true;
    });
    this.setState({ downloadReport });
    this.callHandleProgress(downloadReport);
    let progressAll = [];
    downloadReport.forEach((dwn) => {
      progressAll.push(dwn.progress === 100 || dwn.progressFailed);
    });
    let downloadAll = progressAll.every((pro) => pro);
    if (downloadAll) {
      this.closeAllDownload();
    } else {
      this.setState({ openCancelPopup: true, cancelAll: true });
    }
  };

  closeAllDownload = () => {
    this.setState({
      openDownload: false,
      openCancelPopup: false,
      cancelAll: false,
    });
    if (typeof this.props.handleAppntDisableDownload === "function") {
      this.props.handleAppntDisableDownload();
    }
    if (typeof this.props.handleTransDisableDownload === "function") {
      this.props.handleTransDisableDownload();
    }
    if (typeof this.props.handlePatientDisableDownload === "function") {
      this.props.handlePatientDisableDownload();
    }
    if (typeof this.props.handleDisableDayCollectionDownload === "function") {
      this.props.handleDisableDayCollectionDownload();
    }
    if (typeof this.props.handleDisableFollowUpDownload === "function") {
      this.props.handleDisableFollowUpDownload();
    }
    if (typeof this.props.handleDisableNewLeadDownload === "function") {
      this.props.handleDisableNewLeadDownload();
    }
    let downloadReport = this.state.downloadReport;
    downloadReport.forEach((dwn) => {
      if (!dwn.signedLink) {
        afterLoginApiAxios
          .post(
            `/download-report/cancel`,
            {
              report_type: dwn.requestType,
              request_id: dwn.id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("id_token"),
              },
            }
          )
          .then((res) => {
            C2CConsole.log(res);
          })
          .catch((err) => {
            C2CConsole.log(err);
          });
      }
    });
    this.setState({ downloadReport: [] });
    localStorage.setItem("DownloadReport", "false");
    localStorage.setItem("AppntDisableDownload", "false");
    localStorage.setItem("TransDisableDownload", "false");
    localStorage.setItem("PatientDisableDownload", "false");
    localStorage.setItem("DayCollectionDisableDownload", "false");
    localStorage.setItem("FollowUpDisableDownload", "false");
    localStorage.setItem("NewLeadDisableDownload", "false");
    localStorage.setItem("DownloadReportArr", JSON.stringify([]));
  };

  handleCancelYes = () => {
    let downloadReport = this.state.downloadReport;
    let cancelInd = this.state.cancelInd;
    if (downloadReport[cancelInd].requestType === "appointment") {
      localStorage.setItem("AppntDisableDownload", "false");
      if (typeof this.props.handleAppntDisableDownload === "function") {
        this.props.handleAppntDisableDownload();
      }
    } else if (
      downloadReport[cancelInd].requestType === "transactions" ||
      downloadReport[cancelInd].requestType === "summary"
    ) {
      localStorage.setItem("TransDisableDownload", "false");
      if (typeof this.props.handleTransDisableDownload === "function") {
        this.props.handleTransDisableDownload();
      }
    } else if (downloadReport[cancelInd].requestType === "daybook_collection") {
      localStorage.setItem("DayCollectionDisableDownload", "false");
      if (typeof this.props.handleDisableDayCollectionDownload === "function") {
        this.props.handleDisableDayCollectionDownload();
      }
    } else if (downloadReport[cancelInd].requestType === "follow_up") {
      localStorage.setItem("FollowUpDisableDownload", "false");
      if (typeof this.props.handleDisableFollowUpDownload === "function") {
        this.props.handleDisableFollowUpDownload();
      }
    } else if (downloadReport[cancelInd].requestType === "new_lead") {
      localStorage.setItem("NewLeadDisableDownload", "false");
      if (typeof this.props.handleDisableNewLeadDownload === "function") {
        this.props.handleDisableNewLeadDownload();
      }
    } else {
      localStorage.setItem("PatientDisableDownload", "false");
      if (typeof this.props.handlePatientDisableDownload === "function") {
        this.props.handlePatientDisableDownload();
      }
    }
    afterLoginApiAxios
      .post(
        `/download-report/cancel`,
        {
          report_type: downloadReport[cancelInd].requestType,
          request_id: downloadReport[cancelInd].id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        C2CConsole.log(res);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
    downloadReport.splice(cancelInd, 1);
    if (downloadReport.length === 0) {
      this.setState({ openDownload: false });
      localStorage.setItem("DownloadReport", "false");
    }
    let newArr = [];
    downloadReport.forEach((dwn) => {
      newArr.push({
        filename: dwn.filename,
        id: dwn.id,
        progress: dwn.progress,
        pause: dwn.pause,
        requestType: dwn.requestType,
        signedLink: dwn.signedLink,
        progressFailed: dwn.progressFailed,
      });
    });
    localStorage.setItem("DownloadReportArr", JSON.stringify(newArr));
    this.setState({
      downloadReport: newArr,
      openCancelPopup: false,
      cancelAll: false,
    });
    this.callHandleProgress(newArr);
    this.setDownloadReady(newArr);
  };

  handleCancelNo = () => {
    let downloadReport = this.state.downloadReport;
    downloadReport.forEach((dwn) => {
      dwn.pause = false;
    });
    this.setState({ downloadReport, openCancelPopup: false, cancelAll: false });
    this.callHandleProgress(downloadReport);
    this.setDownloadReady(downloadReport);
  };

  displayCancelPopup = () => {
    const { classes } = this.props;
    const { cancelAll } = this.state;
    return (
      <Dialog
        open={this.state.openCancelPopup}
        classes={{ paper: classes.dialogPaper }}
        aria-labelledby="form-dialog-title"
      >
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          <img src={require("../../assets/warning.svg")} alt="" />
        </div>
        <div className="Cancel-download">Cancel Download</div>
        <div className="Cancel-popup-text">
          Your download is not complete. Would you like to cancel the download?
        </div>
        <div className="Cancel-buttons">
          <div
            className="Cancel-yes-btn"
            onClick={() =>
              cancelAll ? this.closeAllDownload() : this.handleCancelYes()
            }
          >
            Yes
          </div>
          <div className="Cancel-no-btn" onClick={this.handleCancelNo}>
            No
          </div>
        </div>
      </Dialog>
    );
  };

  displayProgressFailedPopup = () => {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.state.progressFailedPopup}
        classes={{ paper: classes.dialogPaper }}
        aria-labelledby="form-dialog-title"
      >
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          <img src={require("../../assets/warning.svg")} alt="" />
        </div>
        <div className="Cancel-download">{this.state.popUpTitle}</div>
        <div className="Cancel-popup-text">{this.state.popUpContent}</div>
        <div className="Cancel-buttons">
          <div className="Cancel-yes-btn" onClick={this.closePopup}>
            ok
          </div>
        </div>
      </Dialog>
    );
  };

  render() {
    const { openDownload, header, open } = this.state;
    return (
      <>
        {openDownload ? (
          <div className="Download-container">
            <div className="Download-header">
              <div className="Download-header-title">{header}</div>
              <div
                className="Download-header-icons"
                onClick={this.toggleExpandCollapse}
              >
                <img
                  src={expandCollapse}
                  alt=""
                  className={open ? "Inverted-arrow" : "Upright-arrow"}
                />
              </div>
              <div
                className="Download-header-icons"
                onClick={this.closeDownload}
              >
                <img src={close} alt="" />
              </div>
            </div>
            {this.displayDownloadBody()}
            {this.displayCancelPopup()}
            {this.displayProgressFailedPopup()}
          </div>
        ) : null}
      </>
    );
  }
}

export default withStyles(styles)(DownloadReport);
